<template>
  <div class="view">
    <h1 class="ui header">Server Error (502)</h1>
    <p>
      <router-link class="ui blue button" :to="$route.query.redirect">Reload page</router-link>
    </p>
  </div>
</template>

<script>
  export default {
    name: 'Error502'
  }
</script>

<style scoped>
  .view { display: flex; flex-direction: column; align-items: center; justify-content: center; }
</style>
